import React from "react";
import "./InfoAlert.scss";
var InfoAlert = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.txtClassName, txtClassName = _d === void 0 ? "txt-grey-shade1" : _d;
    return (React.createElement("div", { className: "info-alert-container ".concat(className, " mb-3") },
        React.createElement("i", { className: "edel-icon-attention-icon lh-22-4 fs-18" }),
        React.createElement("span", { className: "DMSanN_14_400 ".concat(txtClassName) }, title)));
};
export default InfoAlert;
